export enum PaymentType {
  CASH = "CASH",
  CHEQUE = "CHEQUE",
  CREDIT = "CREDIT",
  CREDIT_CARD = "CREDIT_CARD",
  CREDIT_ORG = "CREDIT_ORG",
  DISCOUNT = "DISCOUNT",
  INSURANCE = "INSURANCE",
  MOBILE_MONEY = "MOBILE_MONEY",
  SOCIAL_SECURITY = "SOCIAL_SECURITY",
  TRANSFER = "TRANSFER",
}
